import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Col, Panel, Button, Alert } from 'react-bootstrap';
// src
import { NEW_ORDER_PATH, ORDERS_SUMMARY_PATH, ORDERS_SUMMARY, LANDING } from '../../../routes/routes_production.js';
import { PostRequest } from '../../../api/PostRequest.js';
import '../../styles/sharedComponentsStyles.css';
import '../../styles/commonStyles.css';

class ResponseBox extends React.Component {
	constructor(props) {
		super(props);				

		this.state = { 
			feedback: null, 
			editMode: this.props.editMode
		};	

		this.sendData = this.sendData.bind(this);						
	}

	render() {
		const { invalid, res } = this.props;
		const { feedback } = this.state;

		// Form non valido
		if(invalid) {
			return (
				<FeedbackAlertBox margin="mt-2" alertStyle="danger">
  				<strong>Attenzione! </strong>
				  I dati inseriti non rispettano i criteri richiesti, ricontrolla i campi.
					<br/> Ricorda di inserire <strong>almeno un articolo </strong>,
					di <strong>calcolare</strong> i campi automatici e selezionare la <strong>provenienza</strong>, del cliente!
				</FeedbackAlertBox>		
			);
		}

		// Form valido, post salvataggio 
		if(!invalid && res) {			
			return (  		  
	      	<React.Fragment>
				<FeedbackAlertBox margin="mt-2" alertStyle="success">
					<strong>Salvataggio completato! </strong> I dati rispettano i requisiti. <br/>
					Leggi il riepilogo e premi <strong>Invia</strong> per concludere l'ordine.
				</FeedbackAlertBox>
					
				<Riepilogo res={res} />
					
				<Col xs={12} lg={12}>
					<Button className="btn-primary" onClick={this.sendData} block>INVIA</Button>       
				</Col>  

				{
					(feedback !== null)? 
						<FeedbackAlertBox margin="mt-2" alertStyle={feedback?'success':'danger'}>
								{(feedback)
									?	
										<p><strong>Operazione completata con successo! </strong> L'ordine è stato inviato.</p>
									: 
										<p><strong>Operazione fallita! </strong> L'ordine non è stato inviato.</p>
								}										
								<p>
									<Link to={LANDING}>Nuovo ordine</Link><br/>                 
									<Link to={".."+ORDERS_SUMMARY}>Riepilogo ordini</Link><br/>              
								</p>                
						</FeedbackAlertBox>	: null
				}
		    </React.Fragment>
		  );
		}

		return null;	  
	}	

	// Spedisce i dati dell'ordine per inserimento e mostra a video il feedback serverside
	sendData(e) {				
		if (this.props.confirmSend) {
			let msg = "" +
				"Le modifiche effettuate non sono state salvate. " +
				"Verrà inviato l'ordine nel riepilogo, continuare?";
			// Annulla l'invio e permette il salvataggio
			if(!window.confirm(msg))
				return;			
		}

		// Invia l'ordine e disabilita form e pulsanti,
		// non è necessario se ResponseBox appartiene a EditOrder: evita undefined function
		if (this.props.disableForm !== undefined)
			this.props.disableForm();								
		// Disabilita Invia
		e.target.disabled = true;
		let feedback = null;
		let parent = this;

		let path = (this.state.editMode)? ORDERS_SUMMARY_PATH : NEW_ORDER_PATH;		

        PostRequest(path, this.props.requestBody)
	    .then((res) => {  	    	  	    		      
	      feedback = (res[0] === "response");	// "response" oppure "error" 
	      parent.setState({feedback: feedback});	            
	    })
	    .catch((err) => { // catch in caso di errori non gestiti	      
	      parent.setState({feedback: false}); 	        
	    }); 
	}	
}

class Riepilogo extends React.Component {
  render() {
    return(
    	<Col xs={12} className="mt-2">
      <Panel> 
        <Panel.Heading>Riepilogo</Panel.Heading>
        <Panel.Body>             
          {
            Object.entries(this.props.res).map((entry,i) => 
              entry[0].indexOf("%%%") === -1 ? 
              (                        
                <Col xs={12} lg={12} key={i}> 
                  <p>
                    <strong>
                    {entry[0].indexOf('(') === -1? 
                      entry[0] : entry[0].substring(0, (entry[0].indexOf('(')-1)) } 
                    </strong>: {(entry[1] === ''? '-' : entry[1])}
                  </p>
                </Col>                            
              ) : 
              (    
                <div key={i}>              
                {entry[0] !== "%%%Prenotazione"? (<Col xs={12}><hr /></Col>) : null } 
                <Col xs={12}><h1 className="pageSubTitle">{entry[1].substring(3)}</h1></Col>
                </div>
              )
            )
          }
        </Panel.Body>
      </Panel> 
      </Col>
    );
  }
}

const FeedbackAlertBox = (props) => (
	<Col xs={12} className={props.margin}>
    <Alert bsStyle={props.alertStyle}>
      {props.children}
    </Alert>
  </Col>
);

export { FeedbackAlertBox };
export default withRouter(ResponseBox);



// WEBPACK FOOTER //
// ./src/cmp/Orders/Response/ResponseBox.js